import React, { useState } from "react";
import { Link } from 'react-router-dom';
import googleIcon from './../../assets/images/google-icon.png';
import facebookIcon from './../../assets/images/facebook-icon.png';
import Amplify from 'aws-amplify';
import awsconfig from "../../aws-config";
import { store } from "react-notifications-component";
import Joi from "@hapi/joi";

Amplify.configure(awsconfig);

const initialFormState = {
    email: "",
    password: "",
};

const schema = {
    email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ["com", "net"] } }).label("Email"),
    password: Joi.string().min(6).pattern(new RegExp("^[a-zA-Z0-9]{3,30}$")).label("Password"),
};

const Login = ({ hideLoadingValue, showLoadingValue, history }) => {
    const [form, setForm] = useState(initialFormState);
    const [errors, setErrors] = useState({});

    const handleChange = ({ currentTarget: input }) => {
        const errorMessage = validateProperty(input);
        if (errorMessage) {
            setErrors({
                ...errors,
                [input.name]: errorMessage,
            });
        } else {
            delete errors[input.name];
            setErrors(errors);
        }

        setForm({
            ...form,
            [input.name]: input.value,
        });
    };

    const validateProperty = ({ name, value }) => {
        const userInputObject = { [name]: value };
        const propertySchema = Joi.object({ [name]: schema[name] });
        const { error } = propertySchema.validate(userInputObject, {
            abortEarly: true,
        });
        return error ? error.details[0].message : null;
    };

    const handleSignIn = async (post) => {
        try {
            showLoadingValue();
            const user = await Amplify.Auth.signIn({
                username: form.email,
                password: form.password,
            });
            localStorage.setItem("userInfo", JSON.stringify(user));
            history.push("/app");
        } catch (error) {
            store.addNotification({
                title: "Error!",
                showIcon: true,
                message: error.message,
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true,
                },
            });
        }
        hideLoadingValue();
    };

    return (
        <>
            <div className="login-container">
            <i
          style={{ fontSize: "32px", marginLeft: "18px", marginBottom: "15px", color: "#fff" }}
          class="material-icons dp48"
          onClick={() => {
            window.history.back();
            return false;
          }}
        >
          arrow_back
        </i>
                <h4 className="auth-header-page">Welcome</h4>
                <h4 className="auth-header-page">Back</h4>
                <div className="form-login-section">
                    <div className="row" style={{ display: "flex" }}>
                        <input type="email" className="auth-form-controller" name="email" placeholder="Email" onChange={handleChange}
                            value={form.email} />
                    </div>
                    <div className="row" style={{ display: "flex" }}>
                        <input type="password" className="auth-form-controller" name="password" placeholder="Password" onChange={handleChange}
                            value={form.password} />
                    </div>
                    <div className="row">
                        Forgot your password? <Link className="auth-from-link" to="/auth/forgat-password"> Reset Password </Link>
                    </div>
                    <div className="row">
                        <div className="col s6 padding0">No account? <Link className="auth-from-link" to="/auth/register"> Sign Up </Link></div>
                        <div className="col s6 right-align padding0">
                            <button className="waves-effect waves-light submit-button center" onClick={handleSignIn}>LOGIN</button>
                        </div>
                    </div>
                    <div className="row">
                        Or login using social media
                    </div>
                    <div className="row">
                        <button className="waves-effect waves-light google-sign-in-btn">
                            <img src={googleIcon} alt="g" /> Google
            </button>
                        <button
                            className="waves-effect waves-light facebook-sign-in-btn"
                            style={{ float: "right" }}
                        >
                            <img src={facebookIcon} alt="f" /> Facebook
            </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;